// AJ: prev/next buttons for the scroll-snap carousel. No jQuery.
if (!customElements.get('aj-carousel')) {
  customElements.define(
    'aj-carousel',
    class AjCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.aj-carousel__track');
        if (!this.track) return;
        this.querySelectorAll('.aj-carousel__btn').forEach((button) => {
          button.addEventListener('click', () => this.step(Number(button.dataset.dir)));
        });
      }

      step(direction) {
        const slide = this.track.querySelector('.aj-carousel__slide');
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = slide.getBoundingClientRect().width + gap;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        const atStart = this.track.scrollLeft <= 2;

        // Wrap around at either end, like the old infinite slider.
        if (direction > 0 && atEnd) return this.track.scrollTo({ left: 0 });
        if (direction < 0 && atStart) return this.track.scrollTo({ left: this.track.scrollWidth });
        this.track.scrollBy({ left: direction * distance });
      }
    }
  );
}
